import Segment from '../shared/segment';
import MahakForm from './form';
import MahakTable from './mahak-table';

function Mahak() {
  return (
    <Segment className='justify-text'>
      <Segment
        bg
        color='rose'
        className='my-6 flex flex-wrap items-center justify-center gap-1 text-center text-xl font-bold text-rose-800 lg:text-2xl'
      >
        <span className='w-full xs:w-fit'>از همین امروز</span>
        <span> مسیر دستیاری 1405</span>
        <span> را شروع کنید!</span>
      </Segment>
      <div className='mx-auto my-8 w-full max-w-7xl'>
        <div className='my-8 text-center text-rose-600'>
          <div className='my-4'>
            <p className='my-1 text-lg font-bold'>آزمون رایگان محک</p>
            <p className='text-sm font-medium'>یک شبیه‌ساز 200 سوالی برای سنجش سطح</p>
          </div>
          <div className='my-4'>
            <p className='my-1 text-lg font-bold'>دریافت نقشه راه</p>
            <p className='text-sm font-medium'>(۳ دور مرور تا آزمون)</p>
          </div>
          <div className='my-4'>
            <p className='my-1 text-lg font-bold'>تخفیف تا 100٪</p>
            <p className='text-sm font-medium'>برای آزمون‌های دو هفته‌ای زمستان</p>
          </div>
        </div>
        <div className='my-2 mx-auto w-full max-w-sm'>
          <Segment
            bg
            color='green'
            textAlign='center'
            className='text-xl font-medium text-green-700'
          >
            2000+ داوطلب تاکنون
          </Segment>
        </div>

        <div className='mx-auto w-full max-w-sm'>
          <MahakForm />
        </div>

        <img
          src={process.env.PUBLIC_URL + 'images/mahak.png'}
          alt='mahak'
          className='mx-auto my-8 w-full sm:my-12'
        />

        <div className='my-6'>
          <h3 className='my-2 text-xl font-bold'>
            آزمون محک: آزمونی برای برگشت به روند مطالعه و جهش مطالعاتی
          </h3>
          <p className='font-medium'>آزمون محک چیست و چه ویژگی‌هایی دارد؟</p>
          <ul className='ms-5'>
            <li>
              <span className='font-medium'>مباحث آزمون:</span>
              <span> یک آزمون 200 سوالی از تمام مباحث آزمون دستیاری</span>
            </li>
            <li>
              <span className='font-medium'>تاریخ برگزاری:</span>
              <span> 30 آذر 1404</span>
            </li>
            <li>
              <span className='font-medium'>جامعه آماری:</span>
              <span>
                {' '}
                بیش از 2000 داوطلب تاکنون، بزرگترین جامعه آماری در تاریخ آزمون‌های آنلاین رزیدنتی!
              </span>
            </li>
            <li>
              <span className='font-medium'>برگشت به روند مطالعه:</span>
              <span>
                {' '}
                با شرکت در آزمون محک می‌توانید با تخفیف، وارد آزمون‌های برنامه‌ریزی شده مدمشاور
                (شروع از اول دی) ‌شوید و 3 دور تا آزمون رزیدنتی مطالعه کنید.
              </span>
            </li>
          </ul>
        </div>
        <div className='my-6'>
          <h3 className='my-2 text-xl font-bold'>
            فرصت استثنایی: امکان دریافت تخفیف یا بورسیه برای آزمون‌های دو هفته‌ای مدمشاور
          </h3>
          <p>
            شرکت در آزمون محک تنها راه ورود به طرح تخفیف و بورسیه برای آزمون‌های زمستان به بعد
            مدمشاور است. اگر تاکنون برای آزمون دستیاری 1405 شروع به مطالعه نکرده اید یا دچار افت در
            روند مطالعه شده‌اید، آزمون محک و آزمون‌های دو هفته‌ای مدمشاور (با شروع از اول دی) بهترین
            فرصت برای برگشت به روند مطالعه را برای شما فراهم می کند.
          </p>

          <MahakTable />
        </div>
        <div className='my-6'>
          <h3 className='my-2 text-xl font-bold'>
            آزمون محک نقطه شروع مسیر است، موفقیت اصلی شما در قالب آزمون‌های دو هفته‌ای مدمشاور رقم
            خواهد خورد.
          </h3>
          <p>
            پس از شرکت در آزمون محک، شما با تخفیف وارد آزمون‌های دو هفته‌ای خواهید شد. اولین آزمون
            در تاریخ 12 دی ماه برگزار خواهد شد.
          </p>
          <p>آزمون‌های مدمشاور ویژگی‌های منحصر به فردی دارند، از جمله:</p>
          <div className='my-2 ms-5'>
            <p>
              <span>📅 </span>
              <span className='font-medium'>برنامه‌ریزی دقیق:</span>
              <span> آزمون‌های استاندارد هر ۲ هفته یک بار.</span>
            </p>
            <p>
              <span>🔁 </span>
              <span className='font-medium'>۳ دور مرور:</span>
              <span> اطمینان از پوشش کامل منابع تا روز آزمون.</span>
            </p>
            <p>
              <span>🧠 </span>
              <span className='font-medium'>۵ آزمون جامع:</span>
              <span> شبیه‌سازی دقیق و کامل پس از عید.</span>
            </p>
            <p>
              <span>📞 </span>
              <span className='font-medium'>مشاوره انحصاری:</span>
              <span> عضویت در کانال خصوصی مشاوره مدمشاور.</span>
            </p>
            <p>
              <span>🏷️ </span>
              <span className='font-medium'>تخفیفات ویژه:</span>
              <span> دریافت تخفیف برای سایر خدمات و محصولات مدمشاور.</span>
            </p>
          </div>
        </div>

        <div className='mx-auto w-full max-w-sm'>
          <MahakForm />
        </div>

        <Segment
          bg
          color='rose'
          textAlign='center'
          className='my-6 text-xl font-medium text-rose-600'
        >
          اگر قصد موفقیت در آزمون دستیاری 1405 را دارید، این آخرین فرصت برای ورود به آزمون‌های
          مدمشاور است.
        </Segment>
      </div>
    </Segment>
  );
}

export default Mahak;
